import { createElement, useEffect, useState } from 'react';
import './index.scss';
import RadioGroupItem from './radio-group-item';
function uuid() {
    return Math.random().toString(36).substring(2);
}
const RadioGroup = ({ options, name = uuid(), type = 'button', defaultValue, selectColor = '#F5743F', selectTextColor = 'white', unSelectColor = '#F0F0F0', unSelectTextColor = '#727272', isWrap = false, onChange = () => { }, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const defaultV = options?.[0]?.value || defaultValue || '';
    const [selectedValue, setSelectedValue] = useState(defaultV);
    useEffect(() => {
        if (defaultV) {
            handleChange(defaultV);
        }
    }, [defaultV]);
    const handleChange = (value) => {
        setSelectedValue(value);
        onChange(value);
    };
    const wrapClass = isWrap ? 'flex-wrap: wrap;' : 'flex-wrap: nowrap;overflow-x: auto;';
    _otherProps.style = wrapClass + ' ' + _otherProps.style ? _otherProps.style : '';
    return (createElement("div", { className: "radio-group__panel", ..._otherProps }, (options || []).map((option) => {
        return (createElement(RadioGroupItem, { label: option.label, value: option.value, key: option.value, checked: selectedValue === option.value, name: name, type: type, selectColor: selectColor, selectTextColor: selectTextColor, unSelectColor: unSelectColor, unSelectTextColor: unSelectTextColor, onChange: handleChange }));
    })));
};
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;
